import { useState } from 'react';

function IconChevronUp({
  width = 24,
  height = 24,
  id,
  color = '#BDBDBD',
  hoverColor = '#BDBDBD',
  ...props
}) {
  const [mainColor, setMainColor] = useState(color);
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={width}
        height={height}
        onMouseEnter={() => setMainColor(hoverColor)}
        onMouseLeave={() => setMainColor(color)}
        {...props}
      >
        <defs>
          <path
            id={id}
            d="M17.743 15.738c-.172.175-.343.262-.6.262a.773.773 0 01-.6-.262L12 11.1l-4.543 4.638a.817.817 0 01-1.2 0 .858.858 0 010-1.226l5.143-5.25a.817.817 0 011.2 0l5.143 5.25a.858.858 0 010 1.226z"
          />
        </defs>
        <g fill="none" fillRule="evenodd">
          <mask id={`${id}-b`} fill="#fff">
            <use xlinkHref={`#${id}`} />
          </mask>
          <g fill={mainColor} mask={`url(#${id}-b)`}>
            <path d="M0 0h24v24H0z" />
          </g>
        </g>
      </svg>
    </>
  );
}

export default IconChevronUp;
